import ManageLabFeatures from "@pathwright/features/src/modules/account/manage/ManageLabFeatures"
import ManageCoverPagesFeaturePermissions from "@pathwright/features/src/modules/feature/manage/ManageCoverPagesFeaturePermissions"
import ManageHomeScreenFeaturePermissions, {
  ConfirmLaunch,
  ConfirmPreview
} from "@pathwright/features/src/modules/feature/manage/ManageHomeScreenFeaturePermissions"

export default {
  lab: {
    component: ManageLabFeatures,
    childCards: {
      home: {
        component: ManageHomeScreenFeaturePermissions,
        childCards: {
          "confirm-preview": {
            component: ConfirmPreview
          },
          "confirm-launch": {
            component: ConfirmLaunch
          }
        }
      },
      "cover-pages": {
        component: ManageCoverPagesFeaturePermissions
      }
    }
  }
}
